export default {
    'please-select-account-filter': 'رجاءاٌ اختر حساب من فضلك',
    'please-select-item-filter': 'رجاءاٌ اختر مادة من فضلك',
    'please-select-a-filter': 'رجاءً قم باختيار أحد الفلاتر',
    'total-quantities': 'مجموع الكميات'
}